import './BrowserView.css';
import { useState, useEffect, useRef } from 'react';
import { processTouchCode } from "./func/bookend-api.js"

function BrowserView(props) {
 const [viewerUrl, setViewerUrl] = useState("");
 const [launchHtml, setLaunchHtml] = useState("");
 const frameRef = useRef(null);
 const { cInfo, code, project } = props;

 useEffect(() => {
  setViewerUrl("");
  setLaunchHtml("");

  if (!cInfo) {
   return;
  }

  let isActive = true;

  if (!project) {
   processTouchCode(code, project, startViewer);
   return () => {
    isActive = false;
   };
  }

  const customPath = `/custom/${project}/index.html`;

  fetch(customPath, { cache: "no-store" })
   .then((res) => {
    if (!res.ok) {
     throw new Error(`Failed to load ${customPath}`);
    }
    return res.text();
   })
   .then((html) => {
    if (isActive) {
     if (html.includes("viewer-launch")) {
      setLaunchHtml(html);
     } else {
      processTouchCode(code, project, startViewer);
     }
    }
   })
   .catch(() => {
    if (isActive) {
     processTouchCode(code, project, startViewer);
    }
   });

  return () => {
   isActive = false;
  };
 }, [cInfo, project, code]);

 useEffect(() => {
  if (viewerUrl && frameRef.current) {
   frameRef.current.focus();
  }
 }, [viewerUrl]);

 return (
  <>
   {!viewerUrl && cInfo && (
     <div
      className="viewer-launch"
      onClick={handleLaunchContainerClick}
      dangerouslySetInnerHTML={{ __html: launchHtml }}
     />
   )}
   {viewerUrl && (
    <iframe
     id="viewer-frame"
     ref={frameRef}
     src={`${viewerUrl}`}
    />
   )}
  </>
 );

 function startViewer(res_data) {
   setViewerUrl(`/viewer/${res_data.tokenInfo.contentType}/index.html?token=${res_data.tokenInfo.token}`);
 }

 function handleLaunchClick() {
  processTouchCode(code, project, startViewer);
 }

 function handleLaunchContainerClick(event) {
  const target = event.target;
  if (target.closest && target.closest(".viewer-launch__button")) {
   handleLaunchClick();
  }
 }

}

export default BrowserView;
